import React from 'react';

const PagamentoResultado = ({ tipo, onVoltar }) => {
  const configs = {
    sucesso: {
      icone: '&#10003;',
      iconeBg: 'bg-green-100',
      iconeColor: 'text-green-600',
      titulo: 'Pagamento Confirmado!',
      mensagem: 'Seu plano foi ativado com sucesso. Aproveite todos os recursos!',
      btnColor: 'bg-green-600 hover:bg-green-700',
    },
    pendente: {
      icone: '&#8987;',
      iconeBg: 'bg-yellow-100',
      iconeColor: 'text-yellow-600',
      titulo: 'Pagamento Pendente',
      mensagem: 'Seu pagamento esta sendo processado. O plano sera ativado automaticamente apos a confirmacao.',
      btnColor: 'bg-yellow-600 hover:bg-yellow-700',
    },
    falha: {
      icone: '&#10007;',
      iconeBg: 'bg-red-100',
      iconeColor: 'text-red-600',
      titulo: 'Pagamento nao Aprovado',
      mensagem: 'O pagamento nao foi aprovado. Tente novamente ou escolha outro metodo de pagamento.',
      btnColor: 'bg-red-600 hover:bg-red-700',
    },
  };

  const config = configs[tipo] || configs.falha;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
        <div className={`w-20 h-20 ${config.iconeBg} rounded-full flex items-center justify-center mx-auto mb-6`}>
          <span className={`text-4xl ${config.iconeColor}`} dangerouslySetInnerHTML={{ __html: config.icone }} />
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-3">{config.titulo}</h1>
        <p className="text-gray-600 mb-8">{config.mensagem}</p>
        <button
          onClick={onVoltar}
          className={`w-full py-3 px-6 ${config.btnColor} text-white rounded-lg font-semibold transition-colors`}
        >
          Voltar ao Sistema
        </button>
      </div>
    </div>
  );
};

export default PagamentoResultado;
